import { Link } from "react-router-dom";

export default function Home() {
  return (
    <div className="max-w-xl mx-auto p-6 text-center space-y-4">
      <img
        src="/logo-horizontal.png"
        alt="Tabs"
        className="h-16 mx-auto mb-6"
      />
      <h1 className="text-3xl font-bold mb-6">
        Sua opinião vale perfume com desconto!
      </h1>
      <p className="mb-6">
        {" "}
        Aqui na Tabs, quem manda são os clientes. Vote nos seus perfumes
        favoritos e ajude a escolher os próximos descontos exclusivos da
        comunidade!
      </p>

      <div className="space-y-3">
        <Link
          className="block bg-black text-white py-3 rounded hover:bg-gray-800"
          to="/masculinos"
        >
          Perfumes Masculinos
        </Link>
        <Link
          className="block bg-black text-white py-3 rounded hover:bg-gray-800"
          to="/femininos"
        >
          Perfumes Femininos
        </Link>
        <Link
          className="block bg-black text-white py-3 rounded hover:bg-gray-800"
          to="/arabes"
        >
          Perfumes Árabes
        </Link>
        <Link
          className="block bg-black text-white py-3 rounded hover:bg-gray-800"
          to="/nicho"
        >
          Perfumes de Nicho
        </Link>
      </div>
    </div>
  );
}
